"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Alert;
const styles_1 = require("@material-ui/core/styles");
const clsx_1 = __importDefault(require("clsx"));
const react_1 = __importDefault(require("react"));
const index_1 = require("../../index");
const icons_1 = require("@material-ui/icons");
const Text_1 = __importDefault(require("../Text"));
const core_1 = require("@material-ui/core");
const BACKGROUND_OPACITY = 0.9;
const useStyles = (0, styles_1.makeStyles)({
    alert: {
        display: 'flex',
        width: '100%',
        color: index_1.StyleVariables.colors.text.default,
        padding: `${index_1.StyleVariables.spacing(2)} ${index_1.StyleVariables.spacing(2)} ${index_1.StyleVariables.spacing(2)} ${index_1.StyleVariables.spacing(1)}`,
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0,
        borderRadius: index_1.StyleVariables.spacing(0.5),
        backgroundColor: index_1.StyleVariables.colors.surface.default,
        alignItems: 'center',
        '&.primary': {
            borderColor: index_1.StyleVariables.colors.action.primary.default,
            backgroundColor: (0, styles_1.lighten)(index_1.StyleVariables.colors.action.primary.default, BACKGROUND_OPACITY),
        },
        '&.success': {
            borderColor: index_1.StyleVariables.colors.text.success,
            backgroundColor: (0, styles_1.lighten)(index_1.StyleVariables.colors.text.success, BACKGROUND_OPACITY),
        },
        '&.error': {
            borderColor: index_1.StyleVariables.colors.text.critical,
            backgroundColor: (0, styles_1.lighten)(index_1.StyleVariables.colors.text.critical, BACKGROUND_OPACITY),
        },
        '&.info': {
            borderColor: index_1.StyleVariables.colors.text.info,
            backgroundColor: (0, styles_1.lighten)(index_1.StyleVariables.colors.text.info, BACKGROUND_OPACITY),
        },
    },
    alertIcon: {
        marginLeft: index_1.StyleVariables.spacing(0.5),
        marginRight: index_1.StyleVariables.spacing(1),
        '&.primary': {
            color: index_1.StyleVariables.colors.action.primary.default,
        },
        '&.success': {
            color: index_1.StyleVariables.colors.icon.success,
        },
        '&.error': {
            color: index_1.StyleVariables.colors.icon.critical,
        },
        '&.info': {
            color: index_1.StyleVariables.colors.icon.info,
        },
        width: index_1.StyleVariables.spacing(4),
        height: index_1.StyleVariables.spacing(4),
    },
    verticalStrip: {
        width: index_1.StyleVariables.spacing(1),
        borderTopLeftRadius: index_1.StyleVariables.spacing(0.5),
        borderBottomLeftRadius: index_1.StyleVariables.spacing(0.5),
        '&.primary': {
            backgroundColor: index_1.StyleVariables.colors.action.primary.default,
        },
        '&.success': {
            backgroundColor: index_1.StyleVariables.colors.icon.success,
        },
        '&.error': {
            backgroundColor: index_1.StyleVariables.colors.icon.critical,
        },
        '&.info': {
            backgroundColor: index_1.StyleVariables.colors.icon.info,
        },
    },
    alertWrapper: {
        borderRadius: index_1.StyleVariables.spacing(0.5),
        display: 'flex',
        flexDirection: 'row',
    },
    alertMessage: {
        flexGrow: 1,
        '&.withClose': {
            paddingRight: index_1.StyleVariables.spacing(5),
        },
    },
    alertAction: {
        color: index_1.StyleVariables.colors.icon.default,
    },
});
function AlertIcon({ severity, ...props }) {
    switch (severity) {
        case 'success':
            return react_1.default.createElement(icons_1.CheckCircle, { ...props });
        case 'error':
        case 'info':
        case 'primary':
            return react_1.default.createElement(icons_1.ErrorOutline, { ...props });
    }
}
function Alert({ className, message, children, hideIcon, severity, onClose, dataTestId, }) {
    const classes = useStyles();
    return (react_1.default.createElement("div", { className: (0, clsx_1.default)(className, classes.alertWrapper) },
        react_1.default.createElement("div", { className: (0, clsx_1.default)(classes.verticalStrip, severity) }),
        react_1.default.createElement("div", { className: (0, clsx_1.default)(classes.alert, severity) },
            !hideIcon && (react_1.default.createElement(AlertIcon, { severity: severity, fontSize: "inherit", className: (0, clsx_1.default)(classes.alertIcon, severity) })),
            react_1.default.createElement(Text_1.default, { as: "h6", className: (0, clsx_1.default)(classes.alertMessage, { withClose: !!onClose }), "data-testid": dataTestId }, children || message),
            onClose && (react_1.default.createElement(core_1.IconButton, { onClick: onClose, size: "small" },
                react_1.default.createElement(icons_1.Close, { className: classes.alertAction }))))));
}
